import React from 'react';
import './SocialIcons.css';

// ─── Built-in platform SVG icons ────────────────────────────────────────────

const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.884v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const TwitterIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.259 5.631zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg width="20" height="15" viewBox="0 0 24 17" fill="currentColor">
    <path d="M23.495 2.205a3.02 3.02 0 00-2.122-2.136C19.505 0 12 0 12 0s-7.505 0-9.373.069A3.02 3.02 0 00.505 2.205C0 4.09 0 8 0 8s0 3.91.505 5.795a3.02 3.02 0 002.122 2.136C4.495 16 12 16 12 16s7.505 0 9.373-.069a3.02 3.02 0 002.122-2.136C24 11.91 24 8 24 8s0-3.91-.505-5.795zM9.545 11.568V4.432L15.818 8l-6.273 3.568z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg width="17" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.89a8.16 8.16 0 004.77 1.52V7l-.01-.02a4.85 4.85 0 01-1-.29z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// ─── Platform config map ────────────────────────────────────────────────────
export const PLATFORM_CONFIG = {
  facebook:  { icon: <FacebookIcon />,  color: '#1877F2', bg: '#E7F0FE' },
  instagram: { icon: <InstagramIcon />, color: '#E1306C', bg: '#FCEEF3' },
  linkedin:  { icon: <LinkedInIcon />,  color: '#0077B5', bg: '#E8F4FA' },
  twitter:   { icon: <TwitterIcon />,   color: '#1DA1F2', bg: '#E8F5FD' },
  x:         { icon: <TwitterIcon />,   color: '#000000', bg: '#F0F0F0' },
  youtube:   { icon: <YouTubeIcon />,   color: '#FF0000', bg: '#FEEBEB' },
  tiktok:    { icon: <TikTokIcon />,    color: '#010101', bg: '#F0F0F0' },
  whatsapp:  { icon: <WhatsAppIcon />,  color: '#25D366', bg: '#E8FAF0' },
};

// Match a platform name string to one of the keys above
export const detectPlatform = (name = '') => {
  const lower = name.toLowerCase();
  if (lower.includes('facebook') || lower.includes('fb')) return 'facebook';
  if (lower.includes('instagram') || lower.includes('ig')) return 'instagram';
  if (lower.includes('linkedin'))  return 'linkedin';
  if (lower.includes('twitter'))   return 'twitter';
  if (lower === 'x')               return 'x';
  if (lower.includes('youtube') || lower.includes('yt')) return 'youtube';
  if (lower.includes('tiktok'))    return 'tiktok';
  if (lower.includes('whatsapp'))  return 'whatsapp';
  return null;
};

// ─── Component ───────────────────────────────────────────────────────────────
/**
 * SocialIcons — reusable social media icons row
 *
 * Props:
 *   links    {Array}  – social link objects: { id, name, link, icon (optional img url) }
 *   size     {number} – icon wrapper size in px (default 36)
 *   gap      {number} – gap between icons in px (default 10)
 *   theme    'dark' | 'light'  (default 'dark')
 */
const SocialIcons = ({ links = [], size = 36, gap = 10, theme = 'dark' }) => {
  if (!links || links.length === 0) return null;

  return (
    <div className={`si-row si-${theme}`} style={{ gap }}>
      {links.map((link, idx) => {
        const platform = detectPlatform(link.name);
        const config   = platform ? PLATFORM_CONFIG[platform] : null;
        const href     = link.link || link.url || '#';

        return (
          <a
            key={link.id || idx}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="si-item"
            title={link.name}
            style={{
              '--si-size':    `${size}px`,
              '--si-color':   config?.color || '#fff',
              '--si-bg':      config?.bg    || '#444',
            }}
            aria-label={link.name}
          >
            <span className="si-inner">
              {link.icon ? (
                <img src={link.icon} alt={link.name} className="si-img" />
              ) : config ? (
                config.icon
              ) : (
                <span className="si-initial">
                  {link.name?.charAt(0)?.toUpperCase() || '?'}
                </span>
              )}
            </span>
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
